import { render, staticRenderFns } from "./login-user.vue?vue&type=template&id=58d54c10&scoped=true"
import script from "./login-user.vue?vue&type=script&lang=js"
export * from "./login-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d54c10",
  null
  
)

export default component.exports